export default "__VITE_ASSET__863fe819__"